import api from 'service/api'
// Import direto do leaf: o barrel de helpers puxa o grafo inteiro da aplicação,
// que ainda não está inicializado quando os módulos de service são avaliados.
import buildAnswerFormData from 'helpers/privacyByDesign/buildAnswerFormData'

const dponetAPI = api.create('guestPortal')

// As assinaturas espelham service/modules/dponet/privacyByDesign para que os
// mesmos componentes e hooks atendam ao app e ao portal de convidados.
const list = async (params) => {
  return await dponetAPI.get('/privacy_by_designs', { params })
}

const show = async ({ privacyByDesignId = '' } = {}) => {
  return await dponetAPI.get(`/privacy_by_designs/${privacyByDesignId}`)
}

const create = async (data) => {
  return await dponetAPI.postForm('/privacy_by_designs', {
    privacyByDesign: data,
  })
}

const update = async ({ privacyByDesignId = '', ...params }) => {
  return await dponetAPI.put(`/privacy_by_designs/${privacyByDesignId}`, {
    privacyByDesign: params,
  })
}

// putForm porque o risco assumido envia justificativa com anexos.
const changeStatus = async ({ privacyByDesignId = '', ...params }) => {
  return await dponetAPI.putForm(
    `/privacy_by_designs/${privacyByDesignId}/change_status`,
    {
      privacyByDesign: params,
    },
  )
}

const destroy = async ({ privacyByDesignId = '' }) => {
  return await dponetAPI.delete(
    `/privacy_by_designs/${privacyByDesignId}/soft_delete`,
  )
}

const listQuizTemplates = async (params) => {
  return await dponetAPI.get('/privacy_by_designs/quiz_templates', { params })
}

const addAttachment = async ({ privacyByDesignId = '', ...data }) => {
  return await dponetAPI.postForm(
    `/privacy_by_designs/${privacyByDesignId}/attachments`,
    data,
  )
}

const destroyAttachment = async ({
  privacyByDesignId = '',
  attachmentId = '',
}) => {
  return await dponetAPI.delete(
    `/privacy_by_designs/${privacyByDesignId}/attachments/${attachmentId}`,
  )
}

const replyAnswer = async ({ privacyByDesignId, answerId, ...answerData }) => {
  return await dponetAPI.put(
    `/privacy_by_designs/${privacyByDesignId}/answers/${answerId}/reply`,
    buildAnswerFormData(answerData),
  )
}

const reopenAnswer = async ({ privacyByDesignId, answerId }) => {
  return await dponetAPI.put(
    `/privacy_by_designs/${privacyByDesignId}/answers/${answerId}/reopen`,
  )
}

const destroyAnswerEvidence = async ({
  privacyByDesignId,
  answerId,
  evidenceId,
}) => {
  return await dponetAPI.delete(
    `/privacy_by_designs/${privacyByDesignId}/answers/${answerId}/evidence?evidence_id=${evidenceId}`,
  )
}

const privacyByDesign = {
  addAttachment,
  changeStatus,
  create,
  destroy,
  destroyAttachment,
  destroyAnswerEvidence,
  list,
  listQuizTemplates,
  replyAnswer,
  reopenAnswer,
  show,
  update,
}

export default privacyByDesign
